<div class="badge-wrapper">
  <button
    type="button"
    class="badge"
    [class.badge--active]="isActive$ | async"
    [class.badge--inactive]="!(isActive$ | async)"
    (click)="onBadgeClick()"
  >
    <lucide-icon
      [img]="(isActive$ | async) ? icons.CheckCircle2 : icons.Circle"
      class="badge__icon"
    ></lucide-icon>
    <span class="badge__label">Grading</span>
  </button>

  <!-- Popover for inactive state -->
  @if (showPopover()) {
    <div class="popover" (click)="hidePopover()">
      <div class="popover__arrow"></div>
      <p class="popover__text">Follow the chat to get your grading results</p>
    </div>
  }
</div>
